import ReservationCard, {ReservationCardProps} from './ReservationCard';

export type {ReservationCardProps};
export default ReservationCard;
